import React, { useEffect } from 'react';
import { scroller } from 'react-scroll';
import About from '../components/AboutMe/About';
import HobbiesAndInterest from '../components/HobbiesAndInterest/HobbiesAndInterest';
import WorkExperience from '../components/WorkExperience/WorkExperience';
import TechStack from '../components/TechStack/TechStack';
import Contact from '../components/ContactMe/Contact';
import Menu from '../components/Menu/Menu';
import Recommendations from '../components/Recommendations/Recommendations';
import StayConnected from '../components/StayConnected/StayConnected';
import ScrollToTopButton from '../components/ScrollToTopButton/ScrollToTopButton';
import { consumePendingScrollTarget } from '../constants/navigation';

const HomePage = () => {
  useEffect(() => {
    const pendingTarget = consumePendingScrollTarget();
    if (!pendingTarget) {
      return;
    }

    const timer = setTimeout(() => {
      scroller.scrollTo(pendingTarget, {
        smooth: true,
        duration: 500,
        offset: -70,
      });
    }, 150);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Menu />
      <ScrollToTopButton />

      <section id="about">
        <About />
      </section>
      <section id="hobbies">
        <HobbiesAndInterest />
      </section>
      <section id="experience">
        <WorkExperience />
      </section>
      <section id="stack">
        <TechStack />
      </section>
      <section id="recommendations">
        <Recommendations />
      </section>
      <section id="contact">
        <Contact />
      </section>
      <section id="stayConnected">
        <StayConnected />
      </section>
    </>
  );
};

export default HomePage;
